import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

export const OrangeButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: '#FFFFFF',
  backgroundColor: '##ED6C02',
  '&:hover': {
    backgroundColor: '#E65100',
  },
}));

export const ButtonsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  height: 42,
  button: {
    color: '#212121',
    height: 38,
    width: 38,
    background: '#EEEEEE',
    '&:hover': {
      background: '#e5e5e5',
    },
  },
});

export const TooltipPopperStylesSmall = {
  '.MuiTooltip-tooltip': {
    marginBottom: '6px !important',
    background: '#212121 !important',
  },
};
